//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiVideoOutline,
  mdiMessageText,
  mdiSeal,
  mdiChevronRight,
  mdiInformationOutline,
} from '@mdi/js'
import { computed, useSlots } from '@vue/composition-api'
import { openTab } from '@core/utils'

export default {
  name: 'FacilityCard',
  props: {
    facilityName: {
      type: String,
      default: '',
      required: true,
    },
    facilityAddress: {
      type: String,
      default: '',
      required: true,
    },
    fieldName: {
      type: String,
      default: '',
      required: true,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    images: {
      type: Array,
      default: () => [],
      required: true,
    },
    latitude: {
      type: Number,
      default: 0,
      required: true,
    },
    longitude: {
      type: Number,
      default: 0,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const slots = useSlots()

    const hasIconContent = computed(() => !!slots.icon)

    const onOpenMap = () => {
      if (props.latitude && props.longitude) openTab(`https://www.google.com/maps/search/?api=1&query=${props.latitude},${props.longitude}`, '_blank')
    }

    return {
      hasIconContent,

      onOpenMap,

      icons: {
        mdiVideoOutline,
        mdiMessageText,
        mdiSeal,
        mdiChevronRight,
        mdiInformationOutline,
      },
    }
  },
}
